import { useQuery } from '@tanstack/react-query';
import { PartnersIntroductionService } from '@generated/front';

export function useAllPartnersIntroduction() {
  return useQuery({
    queryKey: ['partners-introductions'],
    queryFn: () =>
      PartnersIntroductionService.partnersIntroductionControllerGetAllPartnersIntroductions(),
  });
}
